import React from 'react'
import PropTypes from 'prop-types'
import {useAuthHelper, AuthHelpers} from '@salesforce/commerce-sdk-react'
import {SignOut} from 'hec/assets/icons'
import {cn} from '@/lib/utils'
import {Button} from '@/components/ui/button'

export const SignOutButton = ({attributes}) => {
    const logout = useAuthHelper(AuthHelpers.Logout)
    const {className, ...restAttributes} = attributes

    const onSignoutClick = async () => {
        try {
            await logout.mutateAsync()
            window.location.assign('/')
        } catch (e) {
            console.error('An error occurred while logging out: ', e)
        }
    }

    return (
        <button
            className={cn('flex items-center', className)}
            onClick={() => onSignoutClick()}
            {...restAttributes}
        >
            <SignOut className="mr-3 w-5 h-5 mb-1" />
            <Button ctaType="link" variant="normal" asChild data-testid="signOutButton">
                Sign Out
            </Button>
        </button>
    )
}
SignOutButton.propTypes = {
    attributes: PropTypes.object
}
export const SignOutButtonDefinition = {
    component: SignOutButton,
    name: 'SignOutButton',
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/user.svg',
    noWrap: true
}
